export default __webpack_public_path__ + "static/media/intro3.3231a863.png";